import { FaTicketAlt } from "react-icons/fa";

export const SUPER_ADMIN_TICKET_MANAGEMENT_ITEMS = [
  {
    id: "sa_tickets_all",
    label: "All Tickets",
    to: "/super-admin/tickets",
    icon: FaTicketAlt,
    end: true,
    activePathPrefix: "/super-admin/tickets",
  },
];

export const SUPER_ADMIN_TICKET_MANAGEMENT_GROUP = {
  id: "ticket_management",
  heading: "Ticket Management",
  icon: FaTicketAlt,
  items: SUPER_ADMIN_TICKET_MANAGEMENT_ITEMS,
};
